import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const JTKFishing = () => (
  <ArticleWrapper articleId="jtk_fishing">
    <div className="prose prose-invert mx-auto p-6">
      <h1>JTK Fishing</h1>
      {/* Add your JTK Fishing article content here */}
      <p>This is a placeholder article for the JTK Fishing keycap set. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default JTKFishing;
